var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("login-layout", [
    _c("div", { staticClass: "center-btn" }, [
      _vm.$whitelabel
        ? _c(
            "p",
            { staticClass: "text-center m-t-xl m-b-lg get-started-contact" },
            [
              _vm._v(
                "For all support enquiries relating to " +
                  _vm._s(_vm.clientName) +
                  " please call us on " +
                  _vm._s(_vm.contactNumber) +
                  " or email us at "
              ),
              _c("a", { attrs: { href: "mailto:" + _vm.contactEmail } }, [
                _vm._v(_vm._s(_vm.contactEmail)),
              ]),
            ]
          )
        : _c(
            "p",
            { staticClass: "text-center m-t-xl m-b-lg get-started-contact" },
            [
              _vm._v(
                "For all support enquiries relating to " +
                  _vm._s(_vm.clientName) +
                  " please call us on " +
                  _vm._s(_vm.contactNumber) +
                  " or email us at "
              ),
              _c("a", { attrs: { href: "mailto:" + _vm.contactEmail } }, [
                _vm._v(_vm._s(_vm.contactEmail)),
              ]),
            ]
          ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex w-full justify-center" },
        [
          _c(
            "router-link",
            {
              ref: "back",
              staticClass: "btn btn-dark",
              attrs: { to: "/login", tag: "button", type: "submit" },
            },
            [_vm._v("\n        Return to Login\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }